import { render } from "./EmdFooter.vue?vue&type=template&id=1a498544&scoped=true"
import script from "./EmdFooter.vue?vue&type=script&lang=js"
export * from "./EmdFooter.vue?vue&type=script&lang=js"

import "./EmdFooter.vue?vue&type=style&index=0&id=1a498544&scoped=true&lang=css"
/* custom blocks */
import block0 from "./EmdFooter.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/data/vstsagent01/user/2766/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a498544"],['__file',"src/components/emerald/organisms/EmdFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a498544"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a498544', __exports__)) {
    console.log('reload')
    api.reload('1a498544', __exports__)
  }
  
  module.hot.accept("./EmdFooter.vue?vue&type=template&id=1a498544&scoped=true", () => {
    console.log('re-render')
    api.rerender('1a498544', render)
  })

}


export default __exports__